import { useTranslator } from '@Localization';
import { DomUtil } from 'leaflet';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { AnnotationToolType } from '../models/annotationToolType';
import { IAnnotationType } from '../models/annotationType';
import { IAnnotationTypeOptions } from '../models/annotationTypeOptions';
import { AnnotationTypeListItem } from './AnnotationTypesListItem';

interface IProps {
  projectId: string;
  annotationTypes: IAnnotationType[];
  annotationTypesOptions: IAnnotationTypeOptions[];
  activeAnnotationTypeId?: string;
  readonly: boolean;
  showList: boolean;
  onAnnotationTypeSelected: (id: string) => Promise<void>;
  onAnnotationTypeOptionsChanged: (projectId: string, annotationTypeOption: IAnnotationTypeOptions) => void;
  onSelectedAnnotationDelete: () => Promise<void>;
  getShortcutKey: (order: number) => string | undefined;
}

export const AnnotationTypesList = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const isSelectToolActive = props.activeAnnotationTypeId === undefined && !props.readonly;
  const element = document.getElementsByClassName('annotation-view')[0] as HTMLElement;

  if (element) {
    if (props.activeAnnotationTypeId === undefined || props.readonly) {
      DomUtil.removeClass(element, 'no-user-select');
    } else {
      DomUtil.addClass(element, 'no-user-select');
    }
  }

  if (!props.showList || props.annotationTypes.length === 0) {
    return <></>;
  }

  const getEscShortcut = (): string => '͠ˎ';

  return (
    <div
      id='annotation-selector'
      className={`annotation-types ${props.readonly ? 'annotation-tools-readonly-overlay' : ''}`}
    >
      <div className='header'>{t('annotation_header')}</div>
      {props.annotationTypes.length && (
        <AnnotationTypeListItem
          key='select_tool'
          id={AnnotationToolType.SELECT}
          projectId={props.projectId}
          onAnnotationTypeClicked={props.onAnnotationTypeSelected}
          onAnnotationTypeOptionsChanged={props.onAnnotationTypeOptionsChanged}
          onSelectedAnnotationDelete={props.onSelectedAnnotationDelete}
          readonly={props.readonly}
          getShortcutKey={getEscShortcut}
          color='var(--joy-palette-text-primary)'
          name={t('select_tool')}
          order={0}
          selectorType={AnnotationToolType.SELECT}
          active={isSelectToolActive}
          isUsed={false}
        />
      )}
      {props.annotationTypes.map((m) => (
        <AnnotationTypeListItem
          key={m.id}
          onAnnotationTypeClicked={props.onAnnotationTypeSelected}
          onAnnotationTypeOptionsChanged={props.onAnnotationTypeOptionsChanged}
          onSelectedAnnotationDelete={props.onSelectedAnnotationDelete}
          getShortcutKey={props.getShortcutKey}
          {...m}
          order={props.annotationTypes.indexOf(m)}
          active={m.id === props.activeAnnotationTypeId && !props.readonly}
          readonly={props.readonly}
          options={props.annotationTypesOptions.find((o) => o.id === m.id)}
        />
      ))}
    </div>
  );
});
